import { css } from '@linaria/core';
import { theming, flex } from 'styles/utils';
export const iconWrapper = `${"omponents__TextIcon__TextIcon_styles_ts-iconWrapper-i1l6acnm"}
  ${flex.init}
  ${flex.alignItems.center}
  ${flex.justifyContent.center}
`;

require("./TextIcon_styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TextIcon_styles.ts");